import { workspaceAttachmentsUrl } from '../urls';
import refresh from '../refresh';

export default async function getWorkspaceAttachments(workspaceId) {
  return refresh(async () => {
    const response = await fetch(`${workspaceAttachmentsUrl}?workspace=${workspaceId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
